import SingleProduct from "../components/layout/products/SingleProduct";

const SingleProductPage = () => {
  return <SingleProduct />;
};

export default SingleProductPage;
